import { Component, h } from 'preact';

class TcrContextMenu extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            visibility: false,
            left: 0,
            right: undefined,
            top: 0,
            bottom: undefined,
            actions: [],
            roles: []
        };

        this.show = this.show.bind(this);
        this.hideContextMenu = this.hideContextMenu.bind(this);
    }

    componentDidMount()
    {
        window.ContextMenu = {
            show: this.show
        };
    }

    show(cm)
    {
        if (cm && !cm.event.shiftKey && !cm.event.altKey && Array.isArray(cm.actions) && cm.actions.length > 0)
        {
            cm.event.preventDefault();
            let left = cm.event.pageX <= window.innerWidth * 0.5;
            let top = cm.event.pageY <= window.innerHeight * 0.5;
            this.setState({
                visibility: true,
                left: left ? cm.event.pageX : undefined,
                right: left ? undefined : window.innerWidth - cm.event.pageX,
                top: top ? cm.event.pageY : undefined,
                bottom: top ? undefined : window.innerHeight - cm.event.pageY,
                actions: cm.actions || []
            });
        }
        else
        {
            cm.event.preventDefault();
            this.setState({
                visibility: false,
                actions: []
            });
        }
    }

    /**
     * 
     * @param {MouseEvent} e 
     */
    hideContextMenu(e)
    {
        this.setState({
            visibility: false,
            actions: []
        });
    }

    render()
    {
        if (!this.state.visibility) return;

        return (
            <div class="context-menu" onClick={this.hideContextMenu} onContextMenu={this.hideContextMenu}>
                <div class="panel" style={{left: this.state.left, right: this.state.right, top: this.state.top, bottom: this.state.bottom}}>
                    {this.state.actions.filter((action) => {
                        return !action.requires_role || (this.state.roles || []).indexOf(action.requires_role) >= 0;
                    }).map((action) => {
                        if (action.type == 'header')
                        {
                            return <div class="header">{action.title}</div>
                        }
                        let click = (event) => {
                            event.stopPropagation();
                            this.hideContextMenu();
                            if (typeof action.onClick === 'function')
                            {
                                action.onClick(event);
                            }
                        };
                        let checked;
                        if (typeof action.checked === 'boolean')
                        {
                            checked = action.checked ? 'true' : 'false';
                        }
                        return (
                            <div class="action" data-checked={checked} data-sep={action.separator} data-disabled={action.disabled} onClick={click}>{action.title}</div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export { TcrContextMenu };
